import { FC } from "react";
import { IconWrapper } from "../IconWrapper";
import { IconProps } from "../Icons.types";

const RewardsStarGradient: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="RewardsStarGradient"
      icon={
        <svg
          width="inherit"
          height="inherit"
          viewBox="0 0 41 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M37.3448 13.3057C38.3074 14.9729 38.3074 17.0271 37.3448 18.6943L31.2183 29.3057C30.2557 30.9729 28.4768 32 26.5516 32H14.2986C12.3735 32 10.5946 30.9729 9.63197 29.3057L3.50547 18.6943C2.54289 17.0271 2.54289 14.9729 3.50547 13.3057L9.63197 2.6943C10.5946 1.02706 12.3735 0 14.2986 0H26.5516C28.4768 0 30.2557 1.02706 31.2183 2.6943L37.3448 13.3057Z"
            fill="url(#paint0_linear_17364_9860)"
          />
          <path
            d="M34.1987 13.4538C34.9823 14.8111 34.9823 16.4833 34.1987 17.8405L29.2114 26.4788C28.4278 27.836 26.9796 28.6721 25.4124 28.6721H15.4378C13.8706 28.6721 12.4224 27.836 11.6388 26.4788L6.65148 17.8405C5.86788 16.4833 5.86788 14.8111 6.65148 13.4538L11.6388 4.81552C12.4224 3.45828 13.8706 2.62219 15.4378 2.62219H25.4124C26.9796 2.62219 28.4278 3.45828 29.2114 4.81552L34.1987 13.4538Z"
            fill="black"
          />
          <path
            d="M34.1985 15.7263C34.9821 16.9531 34.9821 18.4647 34.1985 19.6915L29.2112 27.5001C28.4276 28.727 26.9795 29.4827 25.4123 29.4827H15.4376C13.8704 29.4827 12.4223 28.727 11.6387 27.5001L6.65134 19.6915C5.86774 18.4647 5.86774 16.9531 6.65134 15.7263L11.6387 7.9177C12.4223 6.69084 13.8704 5.93506 15.4376 5.93506H25.4123C26.9795 5.93506 28.4276 6.69084 29.2112 7.9177L34.1985 15.7263Z"
            fill="url(#paint1_linear_17364_9860)"
          />
          <path
            d="M28.3475 17.1287L22.4739 15.66L21.0052 9.78642C20.9728 9.65707 20.8981 9.54225 20.793 9.46021C20.6878 9.37818 20.5583 9.33362 20.4249 9.33362C20.2916 9.33362 20.162 9.37818 20.0569 9.46021C19.9518 9.54225 19.8771 9.65707 19.8446 9.78642L18.376 15.66L12.5024 17.1287C12.3731 17.1611 12.2582 17.2358 12.1762 17.3409C12.0942 17.4461 12.0496 17.5756 12.0496 17.709C12.0496 17.8423 12.0942 17.9718 12.1762 18.077C12.2582 18.1821 12.3731 18.2568 12.5024 18.2892L18.376 19.7579L19.8446 25.6315C19.8771 25.7608 19.9518 25.8756 20.0569 25.9577C20.162 26.0397 20.2916 26.0843 20.4249 26.0843C20.5583 26.0843 20.6878 26.0397 20.793 25.9577C20.8981 25.8756 20.9728 25.7608 21.0052 25.6315L22.4739 19.7579L28.3475 18.2892C28.4768 18.2568 28.5916 18.1821 28.6737 18.077C28.7557 17.9718 28.8003 17.8423 28.8003 17.709C28.8003 17.5756 28.7557 17.4461 28.6737 17.3409C28.5916 17.2358 28.4768 17.1611 28.3475 17.1287ZM20.4369 18.3072C20.2782 18.308 20.1258 18.2457 20.013 18.1341C19.9003 18.0225 19.8365 17.8706 19.8357 17.7119C19.8349 17.5533 19.8971 17.4008 20.0088 17.288C20.1204 17.1753 20.2723 17.1115 20.4309 17.1107H20.4369C20.5956 17.1107 20.7477 17.1737 20.8599 17.2859C20.9721 17.3981 21.0351 17.5503 21.0351 17.709C21.0351 17.8676 20.9721 18.0198 20.8599 18.132C20.7477 18.2442 20.5956 18.3072 20.4369 18.3072ZM14.9558 13.0528C14.893 12.9392 14.8688 12.8083 14.887 12.6798C14.9051 12.5513 14.9646 12.4321 15.0563 12.3403C15.1481 12.2486 15.2673 12.1891 15.3958 12.171C15.5243 12.1529 15.6552 12.177 15.7688 12.2398L17.7263 13.3262L17.3895 14.6735L16.0422 15.0103L14.9558 13.0528ZM23.1236 13.3262L25.0811 12.2398C25.1947 12.177 25.3256 12.1529 25.4541 12.171C25.5826 12.1891 25.7018 12.2486 25.7935 12.3403C25.8853 12.4321 25.9448 12.5513 25.9629 12.6798C25.981 12.8083 25.9569 12.9392 25.8941 13.0528L24.8077 15.0103L23.4604 14.6735L23.1236 13.3262ZM25.8941 22.3651C25.9569 22.4787 25.981 22.6096 25.9629 22.7381C25.9448 22.8666 25.8853 22.9858 25.7935 23.0776C25.7018 23.1693 25.5826 23.2288 25.4541 23.2469C25.3256 23.265 25.1947 23.2409 25.0811 23.1781L23.1236 22.0917L23.4604 20.7444L24.8077 20.4076L25.8941 22.3651ZM17.7263 22.0917L15.7688 23.1781C15.6552 23.2409 15.5243 23.265 15.3958 23.2469C15.2673 23.2288 15.1481 23.1693 15.0563 23.0776C14.9646 22.9858 14.9051 22.8666 14.887 22.7381C14.8688 22.6096 14.893 22.4787 14.9558 22.3651L16.0422 20.4076L17.3895 20.7444L17.7263 22.0917Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_17364_9860"
              x1="20.4251"
              y1="0"
              x2="20.4251"
              y2="32"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C947D9" />
              <stop offset="0.945" stopColor="#FFC37E" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_17364_9860"
              x1="20.4249"
              y1="5.93506"
              x2="20.4249"
              y2="29.4827"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C742DD" />
              <stop offset="1" stopColor="#FFC47F" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default RewardsStarGradient;
